<template>
  <div class="panel-admin-body">
    <div class="d-flex title">
      <modal-link modal-id="How to Use" :content-list="pageContent"></modal-link>
      {{ chart.title }}
      <div class="ml-auto">
        <i v-show="this.$root.getShowMenuIcon() && this.$root.getShowHeaderMenu()" class="fa fa-window-minimize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
        <i v-show="this.$root.getShowMenuIcon() && !this.$root.getShowHeaderMenu()" class="fa fa-window-maximize pl-1 pr-1" aria-hidden="true" @click="toggleHeaderMenu()"></i>
      </div>
    </div>
    <saved-card-menu :entry-client-object="clientObject" :original-saved-cards="clientChartsBySurvey" set-type="survey" view-type="menu"></saved-card-menu>
    <div class="chart-app">
      <chart-criteria
        ref="chartCriteria"
        :include-show-competitor-expectations="true"
        :include-show-pricing-power="true"
        :use-chart-type-card="true"
        display-type-label="Views"
        showUseTTMAsStartDate="true"
        :show-display-type="true"
        :is-comparative="false"
        is-profile-page="true"
        :maximum-competitors="maximumCompetitors"
        :content-list="pageContent"
        @reset-client-chart="resetClientChart"
        @reset-sub-chart-criteria="resetSubChartCriteria"
      ></chart-criteria>
      <div class="row no-gutters">
        <div class="col">
          <div id="chartDislayCard">
            <div id="performance_dashboard">
              <div id="chart-filters" class="row">
                <chart-criteria-results
                  v-show="!generatingChart && displayChartCriteriaResults"
                  ref="chartCriteriaResults"
                  v-bind:criteria-results-list="criteriaResultsList"
                  v-bind:criteria-results-company-list="criteriaResultsCompanyList"
                ></chart-criteria-results>
              </div>
              <chart-display-skeleton v-show="generatingChart"/>
              <ByNeed v-show="isByNeed && !generatingChart" :chart-data="chartData" :content-list="pageContent" :verbatims-data="verbatimsData" @set-recommendations-data="handleRecommendationsData"></ByNeed>
              <ByMoat v-show="isByMoat && !generatingChart" :chart-data="chartData" :content-list="pageContent" :verbatims-data="verbatimsData" @set-recommendations-data="handleRecommendationsData"></ByMoat>
              <ByValue v-show="isByValue && !generatingChart" :chart-data="chartData" :content-list="pageContent" :verbatims-data="verbatimsData" @set-recommendations-data="handleRecommendationsData"></ByValue>
              <ByWinners v-show="isByWinners && !generatingChart" :chart-data="chartData" :content-list="pageContent" @set-recommendations-data="handleRecommendationsData"></ByWinners>
              <ByMoneyballStick v-show="isByMoneyballStick && !generatingChart" :chart-data="chartData" :content-list="pageContent" @set-recommendations-data="handleRecommendationsData"></ByMoneyballStick>
              <ByValueRoadmap v-show="isByValueRoadmap && !generatingChart" :chart-data="chartData" :content-list="pageContent" @set-value-roadmap-id="setValueMapDataId" @set-recommendations-data="handleRecommendationsData"></ByValueRoadmap>
              <ByWordCloud v-show="isByWordCloud && !generatingChart" :chart-data="chartData" :content-list="pageContent" 
              :input-e-chart-criteria="eChartCriteria" @set-recommendations-data="handleRecommendationsData"
              >
              </ByWordCloud>

            </div>
          </div>
        </div>
      </div>
      <download-comments v-show="showDownloadComments && !generatingChart" 
          ref="downloadComments" 
          :input-needs-list="needsList" 
          :is-explorer-page="false" 
          :debug-mode="false" 
          :entry-survey-code="this.surveyCode" 
          :client-object="this.clientObject" 
          :client-chart="this.clientChart" 
          :auto-generate-verbatims="autoGenerateChart" 
          @chart-verbatims="handleChartVerbatims" 
          @save-download-comments-criteria="handleSaveDownloadCommentsCriteria" 
          @sentiments-data="handleSentimentsData">
      </download-comments>
      <product-recommendations v-show="showDownloadComments && !generatingChart" 
          ref="productRecommendations" 
          :entry-survey-code="this.surveyCode" 
          :client-chart="this.clientChart" 
          :client-object="this.clientObject" 
          :auto-generate-recommendations="autoGenerateChart" 
          @save-profile-recommendations-criteria="handleSaveProfileRecommendationsCriteria"
          :enable-include-relative-strength="enableIncludeRelativeStrength" 
          :enable-willingness-to-pay="enableWillingnessToPay" 
          :enable-sentiment-themes="enableSentimentThemes" 
          :recommendations-data="recommendationsData" 
          :sentimentsData="sentimentsData">
      </product-recommendations>

    </div>
    <vue-modal ref="save-chart-confirmation" name="save-chart-confirmation" :width="350" :height="200">
      <save-chart button-label="Save as Card" :chart-title="this.chart.title" :initial-client-chart="this.clientChart" @save="updateClientCharts" @closeModal="closeModal('save-chart-confirmation')"></save-chart>
    </vue-modal>
    <vue-modal ref="print-chart" name="print-chart" :width="350" :height="200">
      <chart-criteria-results
        ref="chartCriteriaResults"
        v-bind:criteria-results-list="criteriaResultsList"
        v-bind:criteria-results-company-list="criteriaResultsCompanyList"
      ></chart-criteria-results>
    </vue-modal>
    <road-map-initiatives ref="roadMapInitiativesForProfileTable" :modal-name="'road-map-initiatives-profile'" :display-initiatives="!isByValueRoadmap" :showCustomInitiative="!isByValueRoadmap" :addOrSaveInitiative="'Save'" :saveEnabled=" !isByValueRoadmap"/>  
    <explore-navigation-modal  ref="exploreNavigationModal" :modal-name="'explore-navigation-modal'" :modal-id="'explore-navigation-modal'"/>  
  </div>
</template>
<script>
import RoadMapInitiatives from "../../modals/RoadMapInitiatives.vue";
import ExploreNavigationModal from "../../modals/ExploreNavigationModal.vue";
import ChartDisplaySkeleton from "../../components/skeleton/ChartDisplaySkeleton.vue";
import ChartCompanyMixins from "../../mixins/ChartCompanyMixins.vue";
import SaveChart from "../../components/chart/SaveChart.vue";
import ByValueRoadmap from "./type/ByValueRoadmap.vue";
import ByNeed from "./type/ByNeed.vue";
import ByMoat from "./type/ByMoat.vue";
import ByWinners from "./type/ByWinners.vue";
import ByMoneyballStick from "./type/ByMoneyballStick.vue";
import ByWordCloud  from "./type/ByWordCloud.vue";
import ByValue from "./type/ByValue.vue";
import ChartService from "../../services/chart.service";
import ErrorService from "../../services/error.service";
import GoogleService from "../../services/google.service";
import AdminService from "../../services/admin.service";
import ValueGroupMap from "../../services/chart/value.group.map.service";
import DownloadComments from "../../components/chart/DownloadComments.vue";
import ProductRecommendations from "../../components/chart/ProductRecommendations.vue";

import $ from "jquery";
export default {
  name: "CompetitiveProfile",
  mixins: [ChartCompanyMixins],
  components: {
    SaveChart,
    ByNeed,
    ByMoat,
    ByWinners,
    ByValueRoadmap,
    ByMoneyballStick,
    ByWordCloud,
    ByValue,
    DownloadComments,
    ProductRecommendations,
    ChartDisplaySkeleton,
    ExploreNavigationModal,
    RoadMapInitiatives
  },
  data() {
    return {
      title: "Profiles",
      pageNumber: 2,
      chartData: [],
      verbatimsData:{},
      verbatimsCriteria: "",
      profileRecommendationsCriteria: "",
      isByMoat: false,
      isByWinners: false,
      isByWordCloud: false,
      isByMoneyballStick: true,
      isByValueRoadmap: false,
      isByNeed: false,
      isByValue: false,
      valueMapData: {
        title: "",
        data: []
      },
      needsList: [],
      valueMapHeight: 450,
      selectedValueRoadMapId: 0, // This is the value selected in the chart criteria
      chartWidth: "",
      displayProfileStrengthLegend: false,
      enableWillingnessToPay: false,
      enableIncludeRelativeStrength: false,
      enableSentimentThemes: false,
      recommendationsData: {},
      sentimentsData: {}
    };
  },
  methods: {
    resetSubChartCriteria() {
      this.$refs.downloadComments.resetValues();
      this.$refs.productRecommendations.resetValues();
    },
    handleSaveDownloadCommentsCriteria(params) {
      this.verbatimsCriteria = params.toString();
      // if (typeof this.verbatimsCriteria != "undefined" && this.verbatimsCriteria != "") {
      //   this.clientChart.criteria =+ "&" + this.verbatimsCriteria;
      // }
      const existingParams = new URLSearchParams(this.clientChart.criteria);
      const newParams = new URLSearchParams(this.verbatimsCriteria);
      for (const [key, value] of newParams.entries()) {
          existingParams.set(key, value); // replaces if already exists
      }
      this.clientChart.criteria = existingParams.toString();
    },
    handleSaveProfileRecommendationsCriteria(params) {
      this.profileRecommendationsCriteria = params.toString();
      // if (typeof this.profileRecommendationsCriteria != "undefined" && this.profileRecommendationsCriteria != "") {
      //   this.clientChart.criteria =+ "&" + this.profileRecommendationsCriteria;
      // }
      const existingParams = new URLSearchParams(this.clientChart.criteria);
      const newParams = new URLSearchParams(this.profileRecommendationsCriteria);
      for (const [key, value] of newParams.entries()) {
          existingParams.set(key, value); // replaces if already exists
      }
      this.clientChart.criteria = existingParams.toString();
    },
    rebuildClientChart(client_id) {
      let useSaveParameters = typeof this.clientChart.criteria != undefined && this.clientChart.criteria != "" && this.autoGenerateChartRun;
      const params = useSaveParameters ? new URLSearchParams(this.clientChart.criteria) : this.$refs.chartCriteria.buildUrlParams(client_id);
      this.clientChart.criteria = params.toString();
    },
    handleChartVerbatims(verbatims) {
      this.verbatimsData = JSON.parse(JSON.stringify(verbatims));
      this.enableSentimentThemes = true;
    },
    setValueMapDataId(valueRoadMapId) {
      this.$refs.chartCriteria.$refs.valueRoadMapSetupRef.$data.valueRoadMapId = valueRoadMapId;
    },
    closeModal(name) {
      if(this.$refs[name] != null) {
        this.$refs[name].visible = false;
      }
    },
    displayChartCallback(response) {
      try {
        this.$refs.downloadComments.$data.pageContent = this.$refs.chartCriteria.$data.pageContent;

        this.$root.processServerResponse();        
        this.generatingChart = false;
        this.chartData = response.data;
        this.isByMoat = this.$refs.chartCriteria.$data.displayType == "moat";
        this.isByNeed = this.$refs.chartCriteria.$data.displayType == "need";
        this.isByValue = this.$refs.chartCriteria.$data.displayType == "value";
        this.isByWinners = this.$refs.chartCriteria.$data.displayType == "winners";
        this.isByWordCloud = this.$refs.chartCriteria.$data.displayType == "nps";
        this.isByMoneyballStick = this.$refs.chartCriteria.$data.displayType == "moneyball-stick";
        this.isByValueRoadmap = this.$refs.chartCriteria.$data.displayType == "value-roadmap";
        if (this.isByMoat) {
          this.valueMapHeight = 420;
        }
        this.enableWillingnessToPay = this.$refs.chartCriteria.$data.showPricingPower == "Y";
        this.enableIncludeRelativeStrength = this.$refs.chartCriteria.$data.showRelationshipStrength == "Y";
        this.enableSentimentThemes = false;
      } catch (err) {
        ErrorService.processException("CompetitiveProfile.displayChartCallback", err, "chart", this);
      }
    },
    goToExploreForProfileTable(needType, needNumber) {
      this.$refs.exploreNavigationModal.$data.needType = needType;
      this.$refs.exploreNavigationModal.$data.needNumber = needNumber;
      this.$refs.exploreNavigationModal.$data.clientChartId = this.clientChart.clientChartId;
      this.$modal.show("explore-navigation-modal");
    },
    async displayInitiativesForProfileTable(element) {
      let needName = element.name;
      let moatName = element.moatName;
      let needNumber = element.needNumber;
      let needType = element.needType;
      let valueRoadMapId = this.selectedValueRoadMapId;
      let sequenceNumber = element.sequenceNumber;
      let moatDescription = element.moatDescription;
      if (moatDescription == null) {
        moatDescription = {
          description: "",
          attributes: "{}"
        };
      }
      let initiative = "";
      let description = "";
      let vm = this;
      await ValueGroupMap.getValueRoadMapInitiative(this.survey.surveyCode, needNumber, needType, valueRoadMapId, (response) => {
          let statusCode = response.data.statusCode;
          if (statusCode == 200) {
            initiative = response.data.data.initiative;
            description = response.data.data.description;
            vm.selectedValueRoadMapId = response.data.data.valueRoadMapId;
          } else {
            AdminService.displayErrorMessage({ text: response.data.message });
          }
      }, this);

      this.$refs.roadMapInitiativesForProfileTable.$data.selectedInitiative = {
        initiative: initiative,
        description: description
      };
      let initiativeSuggestions = element.initiativeSuggestions;
      this.$refs.roadMapInitiativesForProfileTable.$data.title = needName;
      this.$refs.roadMapInitiativesForProfileTable.$data.moatName = moatName;
      this.$refs.roadMapInitiativesForProfileTable.$data.needName = needName;
      this.$refs.roadMapInitiativesForProfileTable.$data.needNumber = needNumber;
      this.$refs.roadMapInitiativesForProfileTable.$data.needType = needType;
      this.$refs.roadMapInitiativesForProfileTable.$data.valueRoadMapId = valueRoadMapId;
      this.$refs.roadMapInitiativesForProfileTable.$data.sequenceNumber = sequenceNumber;
      this.$refs.roadMapInitiativesForProfileTable.$data.initiatives = JSON.parse(JSON.stringify(initiativeSuggestions));
      this.$refs.roadMapInitiativesForProfileTable.$data.moatInitiatives = JSON.parse(JSON.stringify(element.moatInitiatives));
      this.$refs.roadMapInitiativesForProfileTable.$data.moatDescription = JSON.parse(JSON.stringify(moatDescription));
      this.$refs.roadMapInitiativesForProfileTable.loadData();
      this.$modal.show("road-map-initiatives-profile");
    },
    handleRecommendationsData(data) {
      //console.log('final data = ', data);
      this.recommendationsData = data;
    },
    handleSentimentsData(data) {
      this.sentimentsData = data;
    }
  },
  umnounted() {},
  computed: {
    showDownloadComments: function() {
        return this.isByNeed
        || this.isByValue
        || this.isByWordCloud
        || this.isByMoat;
    },
    maximumCompetitors: function() {
      return this.isByMoneyballStick ? 15 : 5;
    },
    showPricingPower: function() {
      return this.$refs.chartCriteria.$data.showPricingPower == "Y";
    },
    mapButtonName: function() {
      if (this.isByValue) {
        return "View Value Map";
      } else if (this.isByMoat) {
        return "View Moat Map";
      } else if (this.isByNeed) {
        return "View Needs Map";
      }
      return "";
    },
    mapType: function() {
      if (this.isByValue) {
        return "value";
      } else if (this.isByMoat) {
        return "moat";
      } else if (this.isByNeed) {
        return "need";
      }
      return "";
    }
  },
  props: {},
  mounted() {},
  created() {
    this.chart = ChartService.getChartAttributes("Profile");
  },
  watch: {
    surveyCode: function(newVal, oldVal) {
      this.verbatimsCriteria = "";
      this.verbatimsData = {};
      this.profileRecommendationsCriteria = "";
    }
  }
};
</script>
